import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Conference } from './../../model/ConferenceTypes';
import classes from './ConferenceCard.module.css';

export interface ConferenceCardProps {
  conference: Conference;
  to: string;
}

export function ConferenceCard({ conference, to }: ConferenceCardProps) {
  const { conferenceName, confStartDate, confEndDate } = conference;

  return (
    <Paper
      className={classes.card}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="10px">
        <TitleCard title={conferenceName} />
        <Group>
          <Text
            c="dimmed"
            size="sm"
          >
            {confStartDate ?? '-'} - {confEndDate ?? '-'}
          </Text>
        </Group>
      </Stack>
    </Paper>
  );
}
